/* eslint-disable react-hooks/exhaustive-deps */
import { 
    Button, 
    CardContent, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogTitle, 
    FormControlLabel, 
    Grid, 
    Paper, 
    Switch, 
    Typography, 
    useTheme 
} from "@mui/material";
import { useEffect, useState } from "react";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MySnackbar from "../../../components/MySnackbar";
import { uploadFilesToFilestorage } from "../../../utils/media-files";
import TemplateEditorModal from "./TemplateEditorModal";

interface BirthdayEmailConfig {
    SendToAllStaff: boolean;
    SendToBirthdayUsers: boolean;
    TemplateAllStaffId: number | null;
    TemplateBirthdayUsersId: number | null;
    TemplateAllStaffUrl?: string;
    TemplateBirthdayUsersUrl?: string;
}


const BirthdayConfigView = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState<boolean>(false);
    const [snackBarMessage, setSnackBarMessage] = useState<any | undefined>();
    
    const [config, setConfig] = useState<BirthdayEmailConfig>({
        SendToAllStaff: false,
        SendToBirthdayUsers: false,
        TemplateAllStaffId: null,
        TemplateBirthdayUsersId: null,
        TemplateAllStaffUrl: "",
        TemplateBirthdayUsersUrl: ""
    });

    const [openModal, setOpenModal] = useState<boolean>(false);
    const [modalTarget, setModalTarget] = useState<'ALL_STAFF' | 'BIRTHDAY_USERS' | null>(null);



    const handleSaveTemplateStorage = async (htmlContent: string): Promise<string | null> => {
        try {
            const blob = new Blob([htmlContent], { type: 'text/html' });
            const generatedFile = new File([blob], `template_${modalTarget?.toLowerCase()}_${Date.now()}.html`, { type: 'text/html' });
            
            const fileArray: File[] = [generatedFile];
            
            const result = await uploadFilesToFilestorage(
                fileArray, 
                (msg) => setSnackBarMessage({ success: false, msg }), 
                false
            );

            if (result === null) return null;

            const filestorageData = result.filestorageData;
            const fileStorageId = filestorageData[0].Id;
            // const fileUrl = filestorageData[0].Url; 
            // Actualizamos el estado local dependiendo de qué opción se esté configurando
            // if (modalTarget === 'ALL_STAFF') {
            //     setConfig(prev => ({ 
            //         ...prev, 
            //         TemplateAllStaffId: fileStorageId,
            //         TemplateAllStaffUrl: fileUrl 
            //     }));
            // } else {
            //     setConfig(prev => ({ 
            //         ...prev, 
            //         TemplateBirthdayUsersId: fileStorageId,
            //         TemplateBirthdayUsersUrl: fileUrl 
            //     }));
            // }

            setSnackBarMessage({
                success: true,
                msg: "Plantilla cargada y procesada correctamente en S3."
            });
            setOpenModal(false);
            return fileStorageId;

        } catch (error) {
            setSnackBarMessage({
                success: false,
                msg: "Error al procesar y subir la plantilla."
            });
            return null;
        }
    };

    const handleOpenEditor = (target: 'ALL_STAFF' | 'BIRTHDAY_USERS') => {
        setModalTarget(target);
        setOpenModal(true);
    };

    const handleSaveFinalConfig = async () => {
        setLoading(true);
        try {
            // const { data } = await saveBirthdayConfig(config);
            console.log("Configuración enviada a S10: ", config);

            setSnackBarMessage({
                success: true,
                msg: "Configuración de onomásticos guardada exitosamente."
            });
        } catch (error) {
            setSnackBarMessage({
                success: false,
                msg: "Error al salvar la configuración en el servidor."
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid item width="100%" marginTop="1.5rem" minHeight="60%">
            <Paper 
                elevation={3}
                style={{
                    width: "100%", 
                    borderRadius: "0.5rem",
                    minHeight: "10rem",
                    padding: "2rem 1.5rem"
                }}
            >

                <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                        <Paper variant="outlined" style={{ padding: "1.5rem", borderRadius: "8px" }}>
                            <Grid container alignItems="center" justifyContent="space-between" marginBottom="1rem">
                                <Grid item>
                                    <Typography variant="subtitle1" fontWeight="700">
                                        Onomástico del día: Notificar a todo el Personal
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        Envía un correo masivo avisando el cumpleaños del compañero.
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={config.SendToAllStaff}
                                                disabled={!config.TemplateAllStaffId}
                                                onChange={(e) => setConfig(prev => ({ ...prev, SendToAllStaff: e.target.checked }))}
                                                color="primary"
                                            />
                                        }
                                        label={config.SendToAllStaff ? "Activo" : "Inactivo"}
                                    />
                                </Grid>
                            </Grid>
                            
                            <CardContent sx={{ backgroundColor: "#F9F9F9", borderRadius: "4px", padding: "1rem !important" }}>
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Typography variant="body2" color={config.TemplateAllStaffId ? "success.main" : "error.main"} fontWeight="500">
                                        {config.TemplateAllStaffId 
                                            ? "✓ Plantilla HTML vinculada correctamente" 
                                            : "⚠ Requiere plantilla HTML para ser activado"
                                        }
                                    </Typography>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        startIcon={<SettingsOutlinedIcon />}
                                        onClick={() => handleOpenEditor('ALL_STAFF')}
                                    >
                                        {config.TemplateAllStaffId ? "Editar Plantilla" : "Configurar Plantilla"}
                                    </Button>
                                </Grid>
                            </CardContent>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Paper variant="outlined" style={{ padding: "1.5rem", borderRadius: "8px" }}>
                            <Grid container alignItems="center" justifyContent="space-between" marginBottom="1rem">
                                <Grid item>
                                    <Typography variant="subtitle1" fontWeight="700">
                                        Onomástico del día: Felicitar solo al Cumpleañero
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        Envía un correo personalizado directamente al colaborador que cumple años.
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={config.SendToBirthdayUsers}
                                                disabled={!config.TemplateBirthdayUsersId}
                                                onChange={(e) => setConfig(prev => ({ ...prev, SendToBirthdayUsers: e.target.checked }))}
                                                color="primary"
                                            />
                                        }
                                        label={config.SendToBirthdayUsers ? "Activo" : "Inactivo"}
                                    />
                                </Grid>
                            </Grid>
                            
                            <CardContent sx={{ backgroundColor: "#F9F9F9", borderRadius: "4px", padding: "1rem !important" }}>
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Typography variant="body2" color={config.TemplateBirthdayUsersId ? "success.main" : "error.main"} fontWeight="500">
                                        {config.TemplateBirthdayUsersId 
                                            ? "✓ Plantilla HTML vinculada correctamente" 
                                            : "⚠ Requiere plantilla HTML para ser activado"
                                        }
                                    </Typography>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        startIcon={<SettingsOutlinedIcon />}
                                        onClick={() => handleOpenEditor('BIRTHDAY_USERS')}
                                    >
                                        {config.TemplateBirthdayUsersId ? "Editar Plantilla" : "Configurar Plantilla"}
                                    </Button>
                                </Grid>
                            </CardContent>
                        </Paper>
                    </Grid>
                </Grid>

                <Grid container justifyContent="flex-end" marginTop="3rem" spacing={2}>
                    <Grid item>
                        <Button 
                            variant="outlined"
                            startIcon={<CloseIcon />}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button 
                            variant="contained"
                            color="primary"
                            disabled={loading}
                            onClick={handleSaveFinalConfig}
                            startIcon={<EmailOutlinedIcon />}
                        >
                            Guardar Configuración
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            <TemplateEditorModal
                open={openModal}
                onClose={() => setOpenModal(false)}
                onSave={handleSaveTemplateStorage}
                initialUrl={modalTarget === 'ALL_STAFF' ? config.TemplateAllStaffUrl : config.TemplateBirthdayUsersUrl}
            />

            {snackBarMessage && (
                <MySnackbar 
                    msg={snackBarMessage.msg} 
                    severity={snackBarMessage.success ? 'success' : 'error'}
                    onClose={() => setSnackBarMessage(undefined)}
                    open={true}
                />
            )}
        </Grid>
    );
};

export default BirthdayConfigView;